import React from "react";
import { useParams } from "react-router-dom";
import "./artigo.css";
import BlogNavbar from "./blogNavbar";

function Artigo() {
  const { slug } = useParams();

  return (
    <>
      <BlogNavbar />

      <section className="artigo-section">
        <div className="container artigo-container">

          <h1>Artigo: {slug.replaceAll("-", " ")}</h1>
          <p>
            Conteúdo completo do artigo exibido aqui.
          </p>

        </div>
      </section>
    </>
  );
}

export default Artigo;
